import React, {useEffect} from 'react';
import Modal from '@organisms/modal';
import {handleLockBrowserScroll, isEmpty} from "@helpers/helpers";

var modalTimeOut = undefined;
var modalOpened = false;
export default function ModalLayout({children, show, setShow, className, modalDialogClass, dialogBodyClassName, scrollable}) {

    useEffect(() => {
        const bodyClasses = document.body.classList;

        if (show) {
            modalOpened = true;
            if (!isEmpty(modalTimeOut)) {
                clearTimeout(modalTimeOut);
            }

            bodyClasses.add('modal-open');

            handleLockBrowserScroll(true);

            window.history.pushState(null, "", window.location.href);

            window.onpopstate = () => {
                window.history.pushState('back', null, null);

                if (show) {
                    setShow(false)
                }
            };
        } else {
            const checkBodyClasses = (!bodyClasses.contains('selection-open') &&
                !bodyClasses.contains('menu-open') &&
                !bodyClasses.contains('filter-open') &&
                !bodyClasses.contains('swiper-open'));

            const otherModalIsOpened = document.querySelector('.modal-container');

            if (checkBodyClasses && isEmpty(otherModalIsOpened)) {
                handleLockBrowserScroll(false);

                modalTimeOut = setTimeout(() => {
                    bodyClasses.remove('modal-open');
                }, 600)
            }

            if (!isEmpty(window.onpopstate) && modalOpened) {
                modalOpened = false;
                window.onpopstate = undefined;
                window.history.back();
            }
        }
    }, [show]);

    return (
        <Modal
            show={show}
            onClose={() => setShow(false)}
            className={(typeof className !== "undefined" ? className : '')}
            modalDialogClass={modalDialogClass}
            dialogBodyClassName={dialogBodyClassName}
            scrollable={scrollable}
        >
            {children}
        </Modal>
    )
}

// styles